export const JOB_ROLE_OPTIONS = [
  { value: 'ceo', label: 'CEO' },
  { value: 'cfo', label: 'CFO' },
  { value: 'treasury', label: 'Treasury' },
  { value: 'procurement', label: 'Procurement' },
  { value: 'ar', label: 'AR' },
  { value: 'ap', label: 'AP' },
  { value: 'owner', label: 'Owner' },
  { value: 'accounting', label: 'Accounting' },
  { value: 'credit', label: 'Credit' },
  { value: 'vp_finance', label: 'VP Finance' },
  { value: 'ap_clerk', label: 'AP Clerk' },
  { value: 'ar_card_acceptance_owner', label: 'AR / Remittance Contact' },
];

export type JobRole = typeof JOB_ROLE_OPTIONS[number]['value'];

/** Fetch job role label from the database. */
export function getJobRoleLabel(value: string | null | undefined): string {
  if (!value) return '';
  const option = JOB_ROLE_OPTIONS.find(opt => opt.value === value);
  return option?.label || value;
}
